import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'

import App from './app/App'
import './styles/index.css'
import { queryClient } from '@/app/lib/http/react-query'
import '@/app/lib/http/interceptors'

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
)
